import React, { useState } from "react";
import request from "request";
import Flash from "flash";
import { isValidPhoneNumber } from 'libphonenumber-js';
import Button from "Button";
import PhoneInput from 'react-phone-number-input/input';
import "./ReceiptSender.scss";

const ReceiptSender = ({ orderId, apiEndpoint }) => {
  const [phone, setPhone] = useState("");
  const [isSendingReceipt, setIsSendingReceipt] = useState(false);
  const [hasSentReceipt, setHasSentReceipt] = useState(false);

  const textReceipt = () => {
    setIsSendingReceipt(true);
    const req = request.post(apiEndpoint, {
      phone: phone,
      type: "text",
    });
    req.then(() => {
      Flash.broadcast("success", "Receipt Sent");
      setPhone("");
      setHasSentReceipt(true);
    });
    req.catch(() => {
      Flash.broadcast("error", "There was an issue sending the receipt");
    });
    req.finally(() => {
      setIsSendingReceipt(false);
      setTimeout(() => {
        setHasSentReceipt(false);
      }, 2000);
    });
  };

  return (
    <div className="ReceiptSender">
      <div className="mb-4">
        <p className="label">Text Receipt:</p>
        <div className="is-flex is-align-items-center">
          <PhoneInput
            country="US"
            name="phone"
            onChange={setPhone}
            value={phone}
            className="input"
            placeholder="Enter phone number"
          />
          <Button
            text="Send"
            disabled={!isValidPhoneNumber(phone || "")}
            className="ml-2"
            loading={isSendingReceipt}
            color={hasSentReceipt ? "green" : "primary"}
            onClick={textReceipt}
          />
        </div>
      </div>
    </div>
  );
};

export default ReceiptSender;
